import {toast} from "react-toastify";
import {ToastError, ToastWarning} from "./toastUtil";
import {IManualModel} from "../types/manualFinder";
import {manualModelToCsvBuilder} from "./modelBuilder";
import {handleGetManualHtml} from "../services/manualFinder/getManualHTML";

export const ExtractedItem = {
    SpecialTools: "SpecialTools",
    ImagesManual: "ImagesManual",
    ImagesAutomatic: "ImagesAutomatic",
}

export const handleManualClick = async (
    manualId: string,
    setLoading: (loading: boolean) => void,
    t: (key: string) => string
) => {
    try {
        setLoading(true);
        let htmlResponse = await handleGetManualHtml(manualId);
        if (htmlResponse) {
            const newWindow = window.open("test", "_blank",);
            if (newWindow) {
                newWindow.document.open();
                newWindow.document.write(htmlResponse);
                newWindow.document.close();
                newWindow.history.pushState({}, "", "manualId=" + manualId)
            }
        } else {
            ToastWarning(t("Manual.NotFound"));
        }
    } catch (error) {
        ToastError(t("Manual.OpeningError"));
    } finally {
        setLoading(false); // Hide spinner
    }
};

export const copyManualIdToClipboard = (manualId: string, message: string) => {
    toast(message, {type: "success"});
    navigator.clipboard.writeText(manualId);
};

export const copyFilenameToClipboard = (filename: string, message: string) => {
    filename = filename.replace('.ai-OEM', '').replace(".ai-Single", "").replace(".ai-TA", "");
    toast(message.replace("{}", filename), {type: "success"})
    navigator.clipboard.writeText(filename)
};

export const handleDownloadManual = (manuals: IManualModel[]) => {
    const csvContent = manualModelToCsvBuilder(manuals);
    const blob = new Blob([csvContent], {type: "text/csv;charset=utf-8;"});
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "matchingManuals.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
